// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import VueCharts from 'vue-charts'
import { routes } from './routes'
import { store } from './store/store'
// uncomment after login implementation
import * as NameSpace from './store/NameSpace'
import loaderState from './store/modules/loader'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'

require('./assets/styles/PSP_design_style.css')

if (process.env.NODE_ENV === 'production') {
  Raven
      .config('https://ee77a8f6a11046338faa9ea657968771@sentry.io/148993')
      .addPlugin(RavenVue, Vue)
      .install()

  console.log = () => null
}

Vue.use(VueRouter)
Vue.use(VueCharts)

const router = new VueRouter({ routes, mode: 'history' })
// Uncomment after login implementation

router.beforeEach((to, from, next) => {
  /**
  * - A loader in progression may not trip on route change as the watchers will not be able to make out
  *   any difference in the state change.
  * - Therefore, mutate the state on every router state change to avoid the loader to go
  *   on an infinite loading spin.
  */
  loaderState.mutations[NameSpace.MUTATE_LOADER_STATE](loaderState.state, false)

  /**
  * - If the user is not logged in.
  *   Don't allow access to pages.
  * - Take user to login page.
  */
  if (to.name !== 'login' && !JSON.parse(
      localStorage.getItem('Parse/74835-54897-3473865-437684/currentUser')
    )
  ) {
    next({name: 'login'})
  } else {
    next()
  }
})
window.eventBus = new Vue()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js